export default __webpack_public_path__ + "static/media/laco-logo.e2565fdc.png";